/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import { FC, useEffect, useState } from "react";
import { editCaseCreationWithupload } from "services/caseServices";
import { CaseCreation } from "types";
import { BASE_URL, LoadingIcon } from "utils/constant";
import { errorHandler, errorHandlerOnForm } from "utils/helper";

type Props = {
  caseData: CaseCreation;
  onClose: (refetch: boolean) => void;
};

const ReAssignProsecutorForm: FC<Props> = ({ caseData, onClose }) => {
  const { showTooltip } = useTooltip();
  const [loading, setLoading] = useState(false);
  const { loginData } = useAuth();

  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [selectedName, setSelectedName] = useState<string | null>(null);

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose(false);
    }
  };

  const [prosecutors, setProsecutors] = useState<
    {
      user: {
        id: string;
        first_name: string;
        last_name: string;
      };
    }[]
  >([]);

  const fetchData = (adminId: string | number, orgId: string | number) => {
    fetch(
      `${BASE_URL}prosecutor-police/investigation-files/fetch-employees-by-org/?admin_id=${adminId}&org_id=${orgId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setProsecutors(
          data?.filter(
            (d: any) =>
              d?.roles?.includes("Prosecutor") ||
              d?.roles?.includes("ProsecutionCaseProsecutor")
          )
        );
      })
      .catch((error) => {
        console.error("Error fetching prosecutors:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (loginData) {
      setLoading(true);
      fetchData(loginData?.admin_unit, loginData?.org_unit);
    }
  }, [loginData]);

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
        <h2 className="text-lg font-semibold text-gray-800">
          Re-Assign Prosecutor
        </h2>
        <p className="text-xs text-gray-500">
          Are you sure you want to terminate this case?
        </p>
        <div className="flex flex-col gap-2 ">
          <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
            Feedback
          </label>

          <select
            className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
            name="reception_method"
            value={selectedId || ""}
            onChange={(e) => {
              const selectedProsecutor = prosecutors.find(
                (p) => p?.user?.id?.toString() === e.target.value
              );
              if (selectedProsecutor) {
                setSelectedId(
                  selectedProsecutor.user?.id !== undefined &&
                    selectedProsecutor.user?.id !== null
                    ? String(selectedProsecutor.user?.id)
                    : ""
                );
                setSelectedName(
                  selectedProsecutor.user?.first_name +
                    " " +
                    selectedProsecutor.user?.last_name
                );
              }
            }}
            required
          >
            <option value={""}>
              {loading ? "Loading ...." : "Select Prosecutor"}
            </option>
            {Array.isArray(prosecutors) &&
              prosecutors.map((p, index) => (
                <option key={index} value={p.user?.id || ""}>
                  {p?.user?.first_name + " " + p?.user?.last_name}
                </option>
              ))}
          </select>
        </div>
        <div className="mt-4 flex justify-between gap-2">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded w-full hover:bg-gray-300"
            onClick={() => {
              onClose(false);
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                        font-[Poppins] cursor-pointer font-[500] w-full
                        text-base rounded-md hover:bg-white hover:text-[#E90101]
                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
            disabled={loading}
            onClick={() => {
              setLoading(true);
              editCaseCreationWithupload({
                id: caseData?.id,
                reassign_prosecutor: selectedName,
                reassign_prosecutor_userid: selectedId,
                // status:
                // attachment
              })
                .then(() => {
                  setLoading(false);
                  showTooltip("Terminated Successfully!", "success");
                  setSelectedId("");
                  setSelectedName("");
                  onClose(true);
                })
                .catch((error) => {
                  setLoading(false);
                  showTooltip(
                    error?.response?.data?.detail ||
                      errorHandlerOnForm(error) ||
                      errorHandler(error) ||
                      "Something went wrong. Please try again.",
                    "error"
                  );
                });
            }}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                {LoadingIcon}
                Loading...
              </div>
            ) : (
              "Re Assign"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReAssignProsecutorForm;
